import { Controller } from "@hotwired/stimulus";

/**
 * The scale of a primary evaluation is the total of the points of the
 * competences ticked (29/10/2026, one-page form): written beside them, and
 * sent as the evaluation's scale.
 */
export default class extends Controller {
  static targets = ["row", "points", "total", "scale"];

  connect() {
    this.sum();
  }

  sum() {
    const total = this.rowTargets.reduce((sum, row) => {
      const ticked = row.querySelector('input[type="checkbox"]')?.checked;
      const points = Number(row.querySelector('[data-competence-total-target="points"]')?.value || 0);
      return ticked ? sum + points : sum;
    }, 0);
    if (this.hasTotalTarget) this.totalTarget.textContent = total;
    if (this.hasScaleTarget) this.scaleTarget.value = total;
  }
}
